import classNames from 'classnames';

import ButtonCircle from '@/components/ButtonCircle';
import { type ScrollerButtonProps } from './ScrollerButton.types';

const ScrollerButton: React.FC<ScrollerButtonProps> = ({
  extraClasses,
  scrollToElement,
}) => {
  const { scrollTo } = window;

  const handleClick = () => {
    const scrollEl =
      document.querySelector(scrollToElement) ?? document.querySelector('body');

    scrollTo({
      top: scrollEl.getBoundingClientRect().top + window.scrollY,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      type="button"
      title="Scroll to element"
      className={classNames('button', 'button--secondary', extraClasses)}
      onClick={handleClick}
    >
      <ButtonCircle
        arrowFill="#fff"
        arrowHeight={17}
        arrowWidth={21}
        extraClasses="button__circle--desktop"
      />
      <ButtonCircle
        arrowFill="#ED560E"
        arrowHeight={17}
        arrowWidth={21}
        extraClasses="button__circle--mobile"
      />
    </button>
  );
};

export default ScrollerButton;
